import "./css/testnotes.css"
import { useEffect, useState } from "react";

const Test = () => {
    const [exam, setExam] = useState();
    const [paper, setPaper] = useState();
    const [message, setMessage] = useState();
    const [validity, setValidity] = useState({});
    const url = process.env.REACT_APP_SERVER_URL;

    useEffect(() => {
        fetch(`${url}/api/availabletest`, {
            method: "get",
            headers: {
                "Content-Type": "application/json",
            }
        }).then((response) => response.json())
            .then((data) => {
                if (data.status === true) {
                    setExam(data.getExam)
                    setPaper(data.getPapers)
                }
                if (data.status === false) {
                    setMessage(data.message);
                }
            })
            .catch(error => console.error("Error fetching data:", error));
    }, [url]);

    const handleAdd = async (paperItem) => {
        if(!localStorage.getItem("token") || !localStorage.getItem("user_id")){
            alert("Please login first");
            window.location.href = "/login";
            return;
        }

        const data = {
            exam: paperItem.exam,
            examUniqueid: paperItem.examUniqueid,
            paper: paperItem.paper,
            paperUniqueid: paperItem.paperUniqueid,
            validity: validity[paperItem.paperUniqueid] || 1,
            name: localStorage.getItem("name"),
            email: localStorage.getItem("email"),
            status: localStorage.getItem("status"),
            token: localStorage.getItem("token"),
            user_id: localStorage.getItem("user_id"),
        }
        
        try {
            const response = await fetch(`${url}/api/courselist`, {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
            const result = await response.json();
            alert(result.message);
        } catch (error) {
            console.error("Error adding course:", error);
            alert("Something went wrong!");
        }
    }

    return (
        <div className="availableTestMainContainer">
            <div className="availableTestListTitle">
                <h2>Available Tests</h2>
            </div>
            
            <div className="availableTestListViewContainer">
                {message && <div className="courseNullMessage">{message}</div>}
                
                {paper && paper.map((paperItem, index) => (
                    <div className="testCard" key={index}>
                        <div className="testCardHeader">
                            <h3 className="examName">{paperItem.exam}</h3>
                            <span className="paperName">{paperItem.paper}</span>
                        </div>
                        
                        <div className="testCardBody">
                            <div className="infoRow">
                                <span className="infoLabel">Language</span>
                                <span className="infoValue">{paperItem.Language}</span>
                            </div>

                            <div className="infoRow">
                                <span className="infoLabel">Validity (Months)</span>
                                <input
                                    type="number"
                                    min="1"
                                    max="12"
                                    className="validityInput"
                                    value={validity[paperItem.paperUniqueid] || 1}
                                    onChange={(e) =>
                                        setValidity({
                                            ...validity,
                                            [paperItem.paperUniqueid]: Number(e.target.value),
                                        })
                                    }
                                />
                            </div>

                            {exam && exam
                                .filter((item) => item.examuniqueid === paperItem.examUniqueid)
                                .map((matchedItem) => (
                                    <div key={matchedItem.examuniqueid} className="matchedInfo">
                                        <div className="infoRow">
                                            <span className="infoLabel">Type</span>
                                            <span className="infoValue">{matchedItem.type}</span>
                                        </div>
                                        <div className="infoRow">
                                            <span className="infoLabel">Place</span>
                                            <span className="infoValue">{matchedItem.area}</span>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        
                        <button className="addButton" onClick={() => handleAdd(paperItem)}>
                            Add to Course
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};
export default Test;